<template>   
  <div>
    <v-card flat>      
        <div>
          <v-row no-gutters fill-height>
            <v-expansion-panels
              v-model="panel"
              :disabled="disabled"
              multiple 
              accordion     
            >
              <v-expansion-panel>
                <v-expansion-panel-header>Select Condition</v-expansion-panel-header>
                <v-expansion-panel-content dense                  
                >               
                   <!-- =============Start Search Condition============= -->
                    <v-row dense >
                        <!-- Ship No -->
                        <v-col                            
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="Ship No"
                              v-model="shipNo" 
                              :items="shipNoList" 
                              return-object 
                              item-value="shipNo" 
                              outlined
                              dense
                            >
                            </v-select>
                        </v-col>
                        <!--Stage Code -->
                        <v-col                            
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4"
                        >
                            <v-select 
                              label="Stage"
                              v-model="stgName" 
                              :items="stgNameList" 
                              return-object 
                              item-value="stgName" 
                              outlined
                              dense
                            >
                            </v-select>
                        </v-col>
                        <!-- Block -->
                        <v-col 
                          class="mt-2"
                          cols="6"
                          sm="6"
                          md="4">
														<v-text-field
                                label="Block"
                                dense 
                                outlined 
                                hide-details="auto"
                                clearable 
                                maxLength="4"
                                v-model="block"
                                @keyup="uppercase"
														    @keyup.enter="btnRetrieve()"
                                                        />
													</v-col>
                        <!-- Retrieve button -->
                        <v-col
                          cols="6"
                          sm="6"
                          md="4"
                        >
                          <v-btn 
                          
                            height = "30px"
                            class="mt-2 "
                            block
                            dense
                            color="success"
                            @click="btnRetrieve"
                          >
                            <v-icon left>
                              {{ icons.mdiMapSearch }}
                            </v-icon>
                            Retrieve
                          </v-btn>
                        </v-col>
                    </v-row>
                    <!-- ==========End Search Condition================= -->                  
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </div>
         <!-- Change theme -->
         <v-fab-transition>
          <v-btn
            @click="dark = !dark"
            absolute
            top
            right
            fab
          >
            <v-icon>mdi-invert-colors</v-icon>
          </v-btn>
        </v-fab-transition>
    </v-card> 
    
    <v-card class="mt-2">  
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>  

          <v-data-table
            :mobile-breakpoint="800"
            :mobile="mobile"
            :items-per-page="listSize"
            :headers="getHeaders()"
            :items="gridMainList"
            :search="search"
            :dense="true"
            :sort-by="[]"
            :sort-desc="[false]"
            :dark="dark"
          >
          <!-- v-slot:[`item.rno`]="{item}" -->
            <template  #[`item.rno`]="{ item }">
              <v-chip
                 small
                :color="getColor(item.rno)"
                :dark="dark"
              >
                {{ item.rno }}
              </v-chip>
            </template>

            <template v-slot:[`item.actions`]="{ item }">             
              <v-chip
                v-if="item.fileCnt > 0"
                outlined
                small
                :color="getColor(item.rno)"
                :dark="dark"
                @click="openDialog(item, 'B')"
              >
                Before: {{ item.fileCnt}} file
              </v-chip>
              
              <v-chip
                v-if="item.fileCntAft > 0"
                outlined
                small
                :color="getColor(item.rno)"
                :dark="dark"
                @click="openDialog(item, 'A')"
              >
                After: {{ item.fileCntAft}} file
              </v-chip>
            </template>

           
           <!--Start Open file detail -->
            <template v-slot:top>
              <v-row justify="center">
                <v-dialog 
                  v-model="dialog"                    
                  scrollable
                  persistent
                  transition="dialog-bottom-transition"
                  >

                  <v-card :dark="dark">
                    <v-card-title class="d-flex cyan darken-1">
                      <v-chip
                        small
                        :dark="dark"
                      >
                        {{ dialogRno }}
                      </v-chip>
                      <v-spacer></v-spacer>
                      <span :dark="dark" class="text-h8 white--text"> {{ formTitle }}</span>

                      <v-spacer></v-spacer>

                      <v-btn
                        :dark="dark"
                        icon
                        @click="close"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text >
                      <DxScrollView
                      height="100%"
                      width="100%">
                        <v-data-table
                            :mobile-breakpoint="800"
                            :mobile="mobile"
                            :items-per-page="5"
                            :headers="dialogHeaders"
                            :items="dialogItemList"
                            :sort-by="[]"
                            :sort-desc="[false]"
                            hide-default-footer
                            dense
                            :dark="dark"
                          >
                            <template  #[`item.rno`]="{ item }">
                              <v-chip
                                small
                                :color="getColor(item.rno)"
                                :dark="dark"
                              >
                                {{ item.rno }}
                              </v-chip>
                            </template>

                            <!-- Open file -->
                            <template v-slot:[`item.openFile`]="{ item }">             
                              <v-chip
                                small
                                :color="getColor(item.rno)"
                                :dark="dark"
                                @click="fileOpen(item)"
                              >
                              Open file
                              </v-chip>
                            </template>

                        </v-data-table>  
                      </DxScrollView>   
                    </v-card-text>
                      
                  </v-card>
                  
                </v-dialog>
              </v-row> 

            </template>
            <!--End Open file detail -->
   
          </v-data-table>               
    </v-card>
    <!-- Scroll To Top -->
    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toTop"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </div>  
</template>

<script>
import  {
        mdiAccount,
        mdiPencil,
        mdiShareVariant,
        mdiDelete,
        mdiSelectSearch,
        mdiMapSearch 

      } from '@mdi/js'

import  { getShipList, 
          getStageList,
      } from '@/api/view/tqm/80/v80comm.js'

import  {
        v80b1030List,
        v80b1030FileList,
      } from '@/api/view/tqm/80/v80b1030.js'

import DxDateBox from 'devextreme-vue/date-box'
import baseview from '@/components/base/baseview.vue' // base page addition
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // Add base when using data grid
import { ftpDownload} from '@/api/view/tqm/common/common.js'
import { DxScrollView } from "devextreme-vue/scroll-view";
import EventBus from '@/components/event-bus';

export default {
name: "v80b1030",
mixins: [baseview, BaseDataGrid],
data: () => ({
  fab: false,
  dark: false,
  icons: {
    mdiAccount,
    mdiPencil,
    mdiShareVariant,
    mdiDelete,
    mdiSelectSearch,
    mdiMapSearch

  },
  chienTest: 'Control file',
  shipNoList: [],
  shipNo: '',
  stgCd: '',
  stgName: '',
  stgNameList: [],
  block: '',
 
  panel: [0],
  disabled: false,
  hover: true,

  // data
  gridMainList: [],
  listSize: 0,
  listFileSize: 0,
  
  mobile: true,
  search: '',
  headers: [
              {
                text: 'No',
                align: 'center',
                value: 'rno',
                divider: true,
                sortable: false,
                class:'light-green darken-3 white--text text-h10',
            
              },
              { text: 'Ship No', sortable: false, divider: true, align: 'center',value: 'shipNo',class:'light-green darken-3 white--text text-h10' },
              { text: 'Block', sortable: false, divider: true, align: 'center',value: 'block',class:'light-green darken-3 white--text text-h10' },
              { text: 'Stage', sortable: false, divider: true, align: 'center',value: 'stgCd',class:'light-green darken-3 white--text text-h10' },
              { text: 'Control file', sortable: false, divider: true, align: 'center',value: 'actions',class:'light-green darken-3 white--text text-h8', sortable: false },
            ],

  dialog: false,
  openFileIndex: -1,
      openFileItem: {
        shipNo: '',
        block: '',
        stgCd: '',
      },
  dialogHeaders: [
                    {
                      text: 'No',
                      align: 'center',
                      value: 'rno',
                      class:'light-green darken-3 white--text text-h8',
                      sortable: false, 
                    },
                    // { text: 'File No', divider: true, align: 'center', value: 'imgNo', class:'light-green darken-3 white--text text-h8' },
                    { text: 'File Name', sortable: false, divider: true, align: 'center', value: 'fileNm', class:'light-green darken-3 white--text text-h8' },
                    { text: 'Control file', sortable: false, divider: true, align: 'center', value: 'openFile', class:'light-green darken-3 white--text text-h8' },

  ],
  dialogItemList: [],
  dialogDiv:'',
  dialogRno:'',

}),
components: {
  DxDateBox,
  DxScrollView,
  // AppButton,
},

computed: {
  formTitle () {
        return this.openFileIndex === -1 ? ' Detail before files' : ' Detail after files'
      },
  },

  watch: {
    /*  options: {
    handler () {
      this.btnRetrieve()
    },
    deep: true,
  }, */
  },

  mounted() {
    this.init()
   
  },
  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab = top > 20
    },
    toTop () {
      this.$vuetify.goTo(0)
    },

    getHeaders(){
        return [
              {
                text: 'No',
                align: 'center',
                value: 'rno',
                divider: true,
                class:'light-green darken-3 white--text text-h10',
            
              },
              { text: 'Ship No', divider: true, align: 'center',value: 'shipNo',class:'light-green darken-3 white--text text-h10' },
              { text: 'Block',divider: true, align: 'center',value: 'block',class:'light-green darken-3 white--text text-h10' },
              { text: 'Stage', divider: true, align: 'center',value: 'stgCd',class:'light-green darken-3 white--text text-h10' },
              { text: this.chienTest, divider: true, align: 'center',value: 'actions',class:'light-green darken-3 white--text text-h8', sortable: false },
            ];
    },
    
    btnRetrieve() {
     
      if (this.shipNo !== 'All') {
        this.gridMainList = []
        this.getMainList()
      } else {
        this.vToastify(this.$t('Sorry!, Select a Ship!'), 'warn')
        return
      }
    },

    init() {   

      this.getList()

    },    
    //getList
    async getList() {
      try {
          this.openLoading('searching')
          let params = {
            shipNo: '',
          }         

          // getShipList
          await getShipList(params).then(res => {
                  this.shipNoList.push('All')
                  res.list.forEach(e => {
                    this.shipNoList.push(e.shipNo)
                  });
                  this.shipNo = this.shipNoList[0]
                })

          await getStageList(params).then(res => {
                  // this.stgNameList.push('All')
                  res.list.forEach(e => {
                    this.stgNameList.push(e.stgCd + ' : ' + e.stgNm)
                  });
                  this.stgName = this.stgNameList[0]
                })

         

          } finally {
              
              this.endLoading()
          }

    },
       

  async getMainList() {
        try {
            this.openLoading('searching')
            
            let stgName = this.stgName
                stgName = stgName.split(' : ')  
                this.stgCd = stgName[0]  
                          
            let params = {                
                shipNo: this.shipNo === 'All' ? '' : this.shipNo,
                stgCd: this.stgCd === 'All' ? '' : this.stgCd,
                block: this.block,

            }
            
            // console.log('######paramsgetMainList===>', params)

            await v80b1030List(params).then(res => {
              let list = []
              // console.log('######v80b1030List===>', res)
                res.list.forEach(e => {
                  list.push({
                    rno: e.rno,
                    shipNo: e.shipNo,
                    block: e.block,
                    stgCd: e.stgCd+' : '+ e.stgNm,
                    blkId: e.blkId,
                    insDate: e.insDate,
                    insTime: e.insTime,
                    inspYn: e.inspYn,
                    urgentYn: e.urgentYn,
                    rejType: e.rejType,
                    fileCnt: e.fileCnt,
                    fileCntAft: e.fileCntAft,
                    div: e.div,
                    divAft: e.divAft,
                    imgNo: e.imgNo,
                    fileNm: e.fileNm,
                    imgNoAft: e.imgNoAft,
                    fileNmAft: e.fileNmAft

                  })
                  
                });

                this.gridMainList = list
                this.listSize = list.length

                if (this.listSize > 0){
                  this.panel = []
                }
                // console.log('######listSize===>', this.listSize)
            })

        } finally {
            this.endLoading()
        }
    },

  getColor (value) {
      if (value > 40) return 'red'
      else if (value > 20) return 'orange'
      else return 'green'
  },  

  openDialog (item, div) {

        // this.dialogDiv = div
        // console.log('#####DialogDivision====>', div)

        if(div==='B'){
          this.openFileIndex = -1          
        }else{
          this.openFileIndex = 1
        }
        this.selOpenFile(item, div)        
        
  },

  selOpenFile(item, div){
    let cntFile;
    let files;
    if (div==='B'){
      cntFile = item.fileCnt
      files = {
        imgNo: item.imgNo,
        fileNm: item.fileNm,
        div: item.div
      }
    }else{
      cntFile = item.fileCntAft
      files = {
        imgNo: item.imgNoAft,
        fileNm: item.fileNmAft,
        div: item.divAft
      }
    }

    if (cntFile == 1){
      this.fileOpen(files)
    }else if (cntFile > 1){
      this.initialize(item, div)
      this.dialogRno = item.rno
      this.dialog = true
    }else{
      this.vToastify(this.$t('Sorry!, No attach file!'), 'warn')
      this.dialog = false
    }

    // console.log('#####Files====>', files)
    

  },
  

  close () {
        this.dialog = false
        this.$nextTick(() => {
          // this.openFileItem = Object.assign({}, this.defaultItem)
          this.openFileIndex = -1
        })
  },    

  async initialize (obj, div) {
      try {
            this.openLoading('searching') 

            let params = {                
                shipNo: obj.shipNo,
                stgCd: obj.stgCd.split(' : ')[0],
                block: obj.block,
                div: div

            }
            
            // console.log('######paramsDialog===>', params)

            await v80b1030FileList(params).then(res => {
              let list = []
              // console.log('######v80b1030FileList===>', res)
                res.list.forEach(e => {

                    list.push({
                      rno: e.rno,
                      imgNo: e.imgNo,
                      fileNm: e.fileNm,
                      div: e.div
                    })
                  
                });

                this.dialogItemList = list
                this.listFileSize = list.length
                // console.log('######listSize===>', this.listSize)
            })

        } finally {
            this.endLoading()
        }
    
  },  
  
  fileOpen(e){
    // console.log('######fileOpen===>', e)
      let dirPath = '';
      if(e.div ==='B'){
        dirPath = 'attachfile/PRODUCTION/DIMENSION/RESULT/';
      }else{
        dirPath = 'attachfile/PRODUCTION/DIMENSION/RESULT_AFT/';
      }

      let fileType = e.fileNm.substring(e.fileNm.lastIndexOf('.') + 1);
      let filePath = dirPath + e.imgNo + '.' + fileType;
      // console.log('######fileType===>', fileType)
      // console.log('######fileNo===>', e.imgNo)
      this.openLoading('searching')
      ftpDownload(filePath, e.imgNo)
      .finally(() => {
        this.endLoading()
      })
  },
  uppercase(){      
        this.block = this.block.toUpperCase()
  },

},

};
</script>
<style lang="css" scoped>

/* Start button invert-colors */
.v-btn--fab.v-size--default.v-btn--absolute.v-btn--top {
    top: 10px;
}

.v-btn--fab.v-size--default {
    height: 45px;
    width: 45px;
}

.v-btn--absolute.v-btn--right, .v-btn--fixed.v-btn--right {
    right: 40px;
}

/* End button invert-colors  */

.v-expansion-panel-header {
    align-items: center;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
    display: flex;
    font-size: 0.9375rem;
    line-height: 0.5;
    min-height: 40px;
    outline: none;
    padding: 10px 10px;
    position: relative;
    transition: 0.3s min-height cubic-bezier(0.25, 0.8, 0.5, 1);
    width: 100%;
    background: silver;
}

.v-expansion-panel--active > .v-expansion-panel-header {
    min-height: 40px;
}
.v-expansion-panel-content__wrap {
    padding: 0 0px 0px;
    flex: 1 1 auto;
    max-width: 100%;
}

/* height for each row */
.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
    height: initial;
    min-height: 30px;
}

/* Size font */
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 10pt;
    height: 30px;
}

.v-dialog > .v-card > .v-card__title {
    font-size: 1rem;
    font-weight: 500;
    letter-spacing: 0.0125em;
    padding: 10px 10px 10px;
}

.v-dialog > .v-card > .v-card__text {
    padding: 0 0px 5px;
}

.v-data-table > .v-data-table__wrapper .v-data-table__mobile-row {
    height: initial;
    min-height: 40px;
}


</style>
